import { useState } from 'react';
import { useSelector } from 'react-redux';

// eslint-disable-next-line import/no-cycle
import LoginModal from 'profile/login/LoginModal';

const NoCustomer = () => {
  const [modal, setModal] = useState(null);

  const settings = useSelector((state) => state.setting.data);
  const { loyalty } = settings;

  const handleLogin = () => {
    setModal('Login');
  };

  return (
    <div className="widget-loyalty-nocustomer">
      <div className="widet-points-on-signup">
        Receive {loyalty.pointsOnCustomerCreate} Bonus Points
      </div>
      <a href="/loyalty-program/join" className="c7-button">
        Join Now
      </a>
      <br />
      Already a member?
      <br />
      <button type="button" onClick={handleLogin} className="c7-button">
        Member Login
      </button>
      <LoginModal modal={modal} setModal={setModal} />
    </div>
  );
};

export default NoCustomer;
